<ion-header class="ion-no-border">
	<ion-toolbar>
		<ion-title>
			Records
		</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="dismiss()">
				<ion-icon name="close-outline"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<div class="space-y-4">
		<div *ngFor="let record of records" class="bg-gray-100 p-4 rounded-lg">
			<div class="font-semibold text-lg mb-2">{{record.date | date:'mediumDate'}}</div>
			<div class="text-gray-600">{{record.customer}}</div>
			<div class="mt-2 text-sm text-gray-500">Score: {{record.score}}</div>
		</div>
	</div>
</ion-content>
